import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import axios from "axios";
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Loader from "../reusable Component/Loader";
import moment from "moment";
import {
  GET_ALL_LEADS,
  GET_DETAILS_BY_MOBILE_NUMBER,
  GET_LEAD_BY_BDM_API,
  GET_TIMELINE,
} from "../../constants";
import TimelineDialog from "../reusable Component/TimelineDialog";
import LongTextComponent from "../Leads Page/LongTextComponent";
import FilterPanel from "./FilterPanel";
import FilterListIcon from "@mui/icons-material/FilterList";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import TimelineIcon from "@mui/icons-material/Timeline";
import dayjs from "dayjs";

function BdmMainLeadTableComponent() {
  const [row, setRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0); // Zero-based index
  const [pageSize, setPageSize] = useState(20); // Rows per page
  const [totalRows, setTotalRows] = useState(0); // Total rows count
  const [totalPages, setTotalPages] = useState(0); // Total rows count

  const [hotStat, setHotStat] = useState(0);
  const [warmStat, setWarmStat] = useState(0);
  const [coldStat, setColdStat] = useState(0);
  const [pendingStat, setPendingStat] = useState(0);
  const [closedStat, setClosedStat] = useState(0);

  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    InquiryType: "",
    Project: "",
    region: "",
    category: "",
    subcategory: "",
    campaignName: "",
    agentName: "",
    search: "",
    page: 0, // Zero-based index
    pageSize: 20, // Default page size
    last_action_date: "",
    followUpDate: "",
  });

  // useEffect(() => {
  //   fetchLeads(currentPage, pageSize, filters);
  // }, [currentPage, pageSize]);

  const fetchLeads = async (filters) => {
    const empId = localStorage.getItem("username");

    const {
      page,
      pageSize,
      InquiryType,
      Project,
      region,
      category,
      subcategory,
      campaignName,
      agentName,
      search,
      last_action_date,
      followUpDate,
    } = filters;

    setLoading(true);
    try {
      const response = await axios.get(
        `${GET_LEAD_BY_BDM_API}/${empId}?page=${
          page + 1
        }&limit=${pageSize}&InquiryType=${InquiryType}&Project=${Project}&region=${region}&category=${category}&subcategory=${subcategory}&campaignName=${campaignName}&agentName=${agentName}&search=${
          search === undefined ? "" : search
        }&updatedDate=${
          last_action_date === null ? "" : last_action_date
        }&followUpDate=${followUpDate === null ? "" : followUpDate}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      const { leads, totalCount, totalPages, categoryStats } = response.data;

      const finalLeads = Array.isArray(leads) ? leads : [];
      const finalStats = categoryStats || {};

      setRow(finalLeads);
      setTotalRows(totalCount || 0);
      setTotalPages(totalPages || 0); // Save total pages to state
      setHotStat(finalStats.hot || 0);
      setWarmStat(finalStats.warm || 0);
      setColdStat(finalStats.cold || 0);
      setPendingStat(finalStats.pending || 0);
      setClosedStat(finalStats.closed || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching leads:", error);
      setLoading(false);
    }
  };

  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

  const columns = [
    { key: "last_action", header: "Last Action" },
    { key: "updatedAt", header: "Lead Updated On" },
    { key: "follow_up_date", header: "Follow-Up Date" },
    { key: "lead_owner", header: "Lead Owner" },
    { key: "CustomerName", header: "Customer Name" },
    { key: "MobileNo", header: "Mobile Number" },
    { key: "region_name", header: "Region Name" },
    { key: "branchName", header: "Branch Name" },
    { key: "category", header: "Category" },
    { key: "sub_category", header: "Sub-Category" },
    { key: "agent_remark", header: "CSE Remark" },
    { key: "bdm_remark", header: "BDM Remark" },
    { key: "InquiryType", header: "Enquiry Type" },
    { key: "call_status", header: "Call Status" },
    { key: "call_type", header: "Call Type" },
    { key: "location", header: "Location" },
    { key: "state_name", header: "State" },
    { key: "CustomerMailId", header: "Customer Mail ID" },
    { key: "createdDate", header: "Date of First Calling" },

    { key: "close_month", header: "Closure Month" },
    { key: "lead_transfer_date", header: "Date of Lead Transfer" },
    { key: "bdm_calling_date", header: "Date of BDM Calling" },
    { key: "source_of_lead_generated", header: "Campaign Name" },
    { key: "AgentName", header: "CSE Name" },
    { key: "Project", header: "Project" },
    { key: "AlternateMobileNo", header: "Alt Mobile Number" },
    { key: "WhatsappNo", header: "Whatsapp Number" },
  ];

  const [openTimeline, setopenTimeline] = useState(false);
  const [timelineLogs, setTimelineLogs] = useState([]);
  const [custData, setCustData] = useState([]);

  const handletimelineClick = (row) => {
    setopenTimeline(true);
    setCustData(row);
    axios
      .get(`${GET_TIMELINE}/${row.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { leadLogs } = response.data;
        setTimelineLogs(leadLogs);
      })
      .catch((error) => {});
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage); // Convert MUI's 0-based to 1-based page number
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset to page 1 on page size change
  };

  // Define your column widths in a mapping
  const columnWidths = {
    SNo: "50px",
    last_action: "150px",
    lead_owner: "180px",
    CustomerName: "150px",
    MobileNo: "150px",
    region_name: "150px",
    category: "120px",
    sub_category: "150px",
    agent_remark: "200px",
    bdm_remark: "200px",
    InquiryType: "150px",
    call_status: "120px",
    call_type: "120px",
    location: "120px",
    state_name: "120px",
    CustomerMailId: "150px",
    createdDate: "150px",
    follow_up_date: "150px",
    close_month: "150px",
    lead_transfer_date: "120px",
    bdm_calling_date: "120px",
    source_of_lead_generated: "150px",
    AgentName: "150px",
    Project: "120px",
    AlternateMobileNo: "150px",
    WhatsappNo: "150px",
    updatedAt: "150px",
    action: "100px",
    branchName: '120px'
  };

  const getColorForTag = (tag) => {
    switch (tag.toLowerCase()) {
      case "hot":
        return "error"; // React blue
      case "warm":
        return "warning"; // JavaScript yellow
      case "cold":
        return "info"; // UI dark blue
      default:
        return "default"; // Default gray
    }
  };

  const handleApplyFilters = (newFilters) => {
    fetchLeads(newFilters); // Adjust page and size as needed
  };

  const [showFilters, setShowFilters] = useState(false); // State to toggle the filter panel

  const handleFilterToggle = () => {
    setShowFilters(!showFilters); // Toggle filter panel visibility
  };

  const handleIconClick = (row) => {
    axios
      .get(`${GET_DETAILS_BY_MOBILE_NUMBER}/${row.MobileNo}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { lead } = response.data;

        // Pass the data to handlingRowData
        handlingRowData1(lead);
      })
      .catch((error) => {
        console.error("Error fetching lead details:", error);
      });
  };

  const handlingRowData1 = (data) => {
    if (!data || data.length === 0) {
      console.warn("No lead data available to transform.");
      return;
    }
    const transformedRows = [data].map((rd, index) => ({
      id: index + 1,
      SNo: index + 1,
      leadId: rd.id,
      CustomerName: rd.CustomerName?.trim() || "-",
      MobileNo: rd.MobileNo || "-",
      AlternateMobileNo: rd.AlternateMobileNo || "-",
      state_name: rd.state_name || "-",
      source_of_lead_generated: rd.Campaign?.CampaignName || "-",
      category: rd.category || "-",
      AgentId: rd.AgentId,
      BDMId: rd.BDMId,
      CustomerMailId: rd.CustomerMailId || "-",
      InquiryType: rd.InquiryType || "-",
      Project: rd.Project || "-",
      Superviser: rd.Superviser,
      SuperviserID: rd.SuperviserID,
      WhatsappNo: rd.WhatsappNo || "-",
      agent_remark: rd.agent_remark || "-",
      close_month: rd.close_month || "-",
      follow_up_date: rd.follow_up_date ? formatDate(rd.follow_up_date) : "-",
      lead_owner: rd.BDM?.EmployeeName || "-",
      lead_transfer_date: rd.lead_transfer_date
        ? formatDate(rd.lead_transfer_date)
        : "-",
      location: rd.location || "-",
      site_location_address: rd.site_location_address || "-",
      region_name: rd.region_name || "-",
      sub_category: rd.sub_category || "-",
      Agent: rd.Agent,
      AgentName: rd.Agent?.EmployeeName || "-",
      BDM: rd.BDM,
      pincode: rd.pincode || "-",
      call_status: rd.call_status,
      call_type: rd.call_type,
      createdDate: rd.createdAt ? formatDate(rd.createdAt) : "-",
      bdm_remark: rd.bdm_remark || "-",
      lead_calling_date: "-",
      bdm_calling_date: "-",
      updatedAt: rd.updatedAt ? formatDate(rd.updatedAt) : "-",
      last_action: rd.last_action || "-",
    }));

    // Store transformed data in localStorage
    localStorage.setItem("leadDetails", JSON.stringify(transformedRows[0]));

    setTimeout(() => navigate("/bdmDetails"), 100);
  };

  const handleCategoryFilter = (value) => {
    const newFilters = {
      InquiryType: "",
      Project: "",
      region: "",
      category: value,
      subcategory: "",
      campaignName: "",
      agentName: "",
      page: 0, // Zero-based index
      pageSize: 20, // Default page size
      last_action_date: "",
      followUpDate: "",
    };
    setFilters(newFilters);
    handleApplyFilters(newFilters);
  };

  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });

  const handleSort = (key) => {
    const isAsc = sortConfig.key === key && sortConfig.direction === "asc";
    setSortConfig({ key, direction: isAsc ? "desc" : "asc" });

    // Apply sorting logic on your table data
    const sortedData = [...row].sort((a, b) => {
      if (a[key] < b[key]) return isAsc ? -1 : 1;
      if (a[key] > b[key]) return isAsc ? 1 : -1;
      return 0;
    });

    // Update your state with the sorted data
    setRow(sortedData);
  };

  return (
    <>
      {loading && <Loader open={loading} />}
      <Box
        sx={{
          display: "flex", // Use flexbox for layout
          flexWrap: "wrap", // Allow wrapping for responsiveness
          gap: "16px", // Add space between boxes
          justifyContent: "start", // Align boxes to the start
          mb: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#000080", // Grey background
            padding: "8px 16px", // Add some padding for spacing
            borderRadius: "8px", // Rounded corners
            border: "1px solid #ccc", // Light border color
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Elevated box shadow
            display: "inline-block", // Ensure it takes only as much space as needed
          }}
        >
          <Typography
            sx={{
              fontWeight: "bold", // Make the text bold
              fontSize: "1.2rem", // Increase font size for prominence
              color: "#fff", // Set a darker color for better visibility
            }}
          >
            Total Leads: {totalRows}
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "#ff0000", // Grey background
            padding: "8px 16px", // Add some padding for spacing
            borderRadius: "8px", // Rounded corners
            border: "1px solid #ccc", // Light border color
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Elevated box shadow
            display: "inline-block", // Ensure it takes only as much space as needed
            cursor: "pointer",
          }}
          onClick={() => handleCategoryFilter("hot")}
        >
          <Typography
            sx={{
              fontWeight: "bold", // Make the text bold
              fontSize: "1.2rem", // Increase font size for prominence
              color: "#fff", // Set a darker color for better visibility
            }}
          >
            Hot: {hotStat}
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "#FFA500", // Grey background
            padding: "8px 16px", // Add some padding for spacing
            borderRadius: "8px", // Rounded corners
            border: "1px solid #ccc", // Light border color
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Elevated box shadow
            display: "inline-block", // Ensure it takes only as much space as needed
            cursor: "pointer",
          }}
          onClick={() => handleCategoryFilter("warm")}
        >
          <Typography
            sx={{
              fontWeight: "bold", // Make the text bold
              fontSize: "1.2rem", // Increase font size for prominence
              color: "#fff", // Set a darker color for better visibility
            }}
          >
            Warm: {warmStat}
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "#0096FF", // Grey background
            padding: "8px 16px", // Add some padding for spacing
            borderRadius: "8px", // Rounded corners
            border: "1px solid #ccc", // Light border color
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Elevated box shadow
            display: "inline-block", // Ensure it takes only as much space as needed
            cursor: "pointer",
          }}
          onClick={() => handleCategoryFilter("cold")}
        >
          <Typography
            sx={{
              fontWeight: "bold", // Make the text bold
              fontSize: "1.2rem", // Increase font size for prominence
              color: "#fff", // Set a darker color for better visibility
            }}
          >
            Cold: {coldStat}
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "#DE3163", // Grey background
            padding: "8px 16px", // Add some padding for spacing
            borderRadius: "8px", // Rounded corners
            border: "1px solid #ccc", // Light border color
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Elevated box shadow
            display: "inline-block", // Ensure it takes only as much space as needed
            cursor: "pointer",
          }}
          onClick={() => handleCategoryFilter("pending")}
        >
          <Typography
            sx={{
              fontWeight: "bold", // Make the text bold
              fontSize: "1.2rem", // Increase font size for prominence
              color: "#fff", // Set a darker color for better visibility
            }}
          >
            Pending: {pendingStat}
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "#0BDA51", // Grey background
            padding: "8px 16px", // Add some padding for spacing
            borderRadius: "8px", // Rounded corners
            border: "1px solid #ccc", // Light border color
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Elevated box shadow
            display: "inline-block", // Ensure it takes only as much space as needed
            cursor: "pointer",
          }}
          onClick={() => handleCategoryFilter("closed")}
        >
          <Typography
            sx={{
              fontWeight: "bold", // Make the text bold
              fontSize: "1.2rem", // Increase font size for prominence
              color: "#fff", // Set a darker color for better visibility
            }}
          >
            Closed: {closedStat}
          </Typography>
        </Box>
      </Box>

      <div >
        <Paper>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>

            <FilterPanel
              filters={filters}
              setFilters={setFilters}
              onApplyFilters={handleApplyFilters}
            />
          </div>

          <TableContainer
            sx={{
              boxShadow: 2,
              borderRadius: "8px",
              margin: "16px 0",
            }}
          >
            <Table
              sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                  <TableCell
                    key={"Sno"}
                    align="center"
                    sx={{
                      width: columnWidths["SNo"] || "auto",
                      padding: 0,
                    }}
                  >
                    SNo
                  </TableCell>
                  {columns.map((column) => (
                    <TableCell
                      key={column.key}
                      align="center"
                      sx={{
                        width: columnWidths[column.key] || "auto",
                        padding: 0,
                      }}
                      sortDirection={
                        sortConfig.key === column.key
                          ? sortConfig.direction
                          : false
                      }
                    >
                      <TableSortLabel
                        active={sortConfig.key === column.key}
                        direction={
                          sortConfig.key === column.key
                            ? sortConfig.direction
                            : "asc"
                        }
                        onClick={() => handleSort(column.key)}
                      >
                        {column.header}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell
                    key={"action"}
                    align="center"
                    sx={{
                      width: columnWidths["action"] || "auto",
                      padding: 0,
                      position: "sticky", // Make the cell sticky
                      right: 0, // Align it next to the Action column
                      backgroundColor: "#EEF0F4", // Set background color for visibility
                      zIndex: 10, // Higher z-index to stay above other cells
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={27}>No Data Available Yet.</TableCell>
                  </TableRow>
                ) : (
                  row.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["SNo"] || "auto",
                          padding: 0,
                        }}
                      >
                        {filters.page * filters.pageSize + index + 1}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["last_action"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.last_action || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["updatedAt"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.updatedAt === null || row.updatedAt === undefined
                          ? "-"
                          : formatDate(row.updatedAt)}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["follow_up_date"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.follow_up_date === null ||
                        row.follow_up_date === undefined
                          ? "-"
                          : formatDate(row.follow_up_date)}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["lead_owner"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.BDMName || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["CustomerName"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.CustomerName || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["MobileNo"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.MobileNo || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["region_name"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.region_name || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["branchName"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.branchName || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["category"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.category === "-" ? (
                          "-"
                        ) : (
                          <Chip
                            label={row.category}
                            color={`${getColorForTag(row.category)}`}
                            size="small"
                            sx={{ textTransform: "capitalize" }}
                          />
                        )}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["sub_category"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.sub_category || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["agent_remark"] || "auto",
                          padding: 0,
                        }}
                      >
                        <LongTextComponent
                          text={
                            row.agent_remark === null ||
                            row.agent_remark === undefined
                              ? "-"
                              : row.agent_remark
                          }
                          maxLength={50}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["bdm_remark"] || "auto",
                          padding: 0,
                        }}
                      >
                        <LongTextComponent
                          text={
                            row.bdm_remark === null ||
                            row.bdm_remark === undefined
                              ? "-"
                              : row.bdm_remark
                          }
                          maxLength={50}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["InquiryType"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.InquiryType || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["call_status"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.call_status || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["call_type"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.call_type || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["location"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.location || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["state_name"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.state_name || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["CustomerMailId"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.CustomerMailId || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["createdDate"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.createdDate === null ||
                        row.createdDate === undefined
                          ? "-"
                          : row.createdDate}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["close_month"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row?.close_month ? dayjs(row.close_month).format("MMM-YYYY") : "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["lead_transfer_date"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.lead_transfer_date === null ||
                        row.lead_transfer_date === undefined
                          ? "-"
                          : formatDate(row.lead_transfer_date)}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["bdm_calling_date"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.bdm_calling_date || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width:
                            columnWidths["source_of_lead_generated"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.Campaign?.CampaignName || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["AgentName"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.AgentName || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["Project"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.Project || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["AlternateMobileNo"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.AlternateMobileNo || "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["WhatsappNo"] || "auto",
                          padding: 0,
                        }}
                      >
                        {row.WhatsappNo || "-"}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          width: columnWidths["action"] || "auto",
                          padding: 0,
                          position: "sticky", // Make the cell sticky
                          right: 0, // Align it next to the Action column
                          backgroundColor: "#EEF0F4", // Set background color for visibility
                          zIndex: 10, // Higher z-index to stay above other cells
                          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Tooltip title="Timeline" arrow>
                          <IconButton
                            onClick={() => handletimelineClick(row)}
                            style={{
                              border: "1px solid",
                              borderRadius: "4px",
                              margin: "5px",
                              width: "24px",
                              height: "24px",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundColor: "#fff",
                            }}
                            color="primary"
                          >
                            <TimelineIcon fontSize="small" color="primary" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View" arrow>
                          <IconButton
                            style={{
                              border: "1px solid",
                              borderRadius: "4px",
                              padding: "2px",
                              width: "24px",
                              height: "24px",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundColor: "#fff",
                            }}
                            color="primary"
                            onClick={() => handleIconClick(row)}
                          >
                            <VisibilityIcon fontSize="small" color="primary" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={totalRows ?? 0} // Fallback to 0 if totalRows is undefined or null
            page={filters.page >= 0 ? filters.page : 0} // Use page from filters, fallback to 0 if invalid
            onPageChange={(event, newPage) => {
              setFilters((prevFilters) => {
                const updatedFilters = { ...prevFilters, page: newPage };
                fetchLeads(updatedFilters); // Fetch leads with the updated page
                return updatedFilters;
              });
            }}
            rowsPerPage={filters.pageSize > 0 ? filters.pageSize : 10} // Use pageSize from filters, fallback to 10 if invalid
            onRowsPerPageChange={(event) => {
              const newPageSize = parseInt(event.target.value, 10);
              setFilters((prevFilters) => {
                const updatedFilters = {
                  ...prevFilters,
                  pageSize: newPageSize,
                  page: 0,
                }; // Reset to page 0 when rows per page change
                fetchLeads(updatedFilters); // Fetch leads with the updated pageSize
                return updatedFilters;
              });
            }}
            rowsPerPageOptions={[10, 20, 25]} // Options for rows per page
          />
        </Paper>
      </div>
      <TimelineDialog
        open={openTimeline}
        setOpen={setopenTimeline}
        timelineLogs={timelineLogs}
        custData={custData}
      ></TimelineDialog>
    </>
  );
}

export default BdmMainLeadTableComponent;
